import {Vue} from 'ui.vue';



import './BXmakerAuthuserphoneEnterForget.styl';

import './BXmakerAuthuserphoneEnterForgetForm';
import './BXmakerAuthuserphoneEnterSmsCode';
import './BXmakerAuthuserphoneEnterUserCall';
import './BXmakerAuthuserphoneEnterBotCall';
import './BXmakerAuthuserphoneEnterBotSpeech';




Vue.component('BXmakerAuthuserphoneEnterForget', {
    name: 'BXmakerAuthuserphoneEnterForget',
    data() {
        return {

        };
    },
    computed: {

    },
    methods: {

    },

    template: `
            <div class="bxmaker-authuserphone-enter-forget"  >
                
                <BXmakerAuthuserphoneHeader class="bxmaker-authuserphone-enter-auth__title" >
                    {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_FORGET_TITLE}}
                </BXmakerAuthuserphoneHeader>    
                                              
                <BXmakerAuthuserphoneEnterForgetForm 
                    v-show="!$root.isShowConfirmation" 
                />   
                
                                        
                <BXmakerAuthuserphoneEnterSmsCode  
                    v-show="$root.isNeedShowConfirmationSmsCode"                                    
                /> 
                    
                <BXmakerAuthuserphoneEnterUserCall  
                    v-show="$root.isNeedShowConfirmationUserCall"   
                /> 
                    
                <BXmakerAuthuserphoneEnterBotCall 
                     v-show="$root.isNeedShowConfirmationBotCall"                 
                />  
                
                <BXmakerAuthuserphoneEnterBotSpeech 
                     v-show="$root.isNeedShowConfirmationBotSpeech"                 
                />  
                    
                <div class="bxmaker-authuserphone-enter-auth__change-confirm" v-if="$root.isNeedShowChangeConfirmation"  >
                     <BXmakerAuthuserphoneLink @onClick="$root.changeConfirmationType" >
                        {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_CHANGE_CONFIRM_TYPE}}   
                     </BXmakerAuthuserphoneLink> 
                </div>   
                    
                    
                <div class="bxmaker-authuserphone-enter-auth__toregistration" v-if="!$root.isShowConfirm">
                     <BXmakerAuthuserphoneLink @onClick="$root.toAuth" >
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_TO_AUTH}}   
                    </BXmakerAuthuserphoneLink> 
                </div>                
                             
            </div>
        `,
});